import React, { useEffect, useState } from 'react';
import { Loader } from 'js/components/common/Loader';
import { getScript } from 'js/utils/scripts.util';
import { useIsMounted } from 'js/hooks/useIsMounted';

import * as constants from './contacts';

import style from './CAFMultiFactorAuthentication.scss';

export const CAFMultiFactorAuthentication = ({
    cpf,
    trustJwt,
    identityJwt,
    policy,
    metadata,
    setResponse,
    setError
}) => {
    const isMounted = useIsMounted();
    const [loaded, setLoaded] = useState(false);
    const [sdk, setSDK] = useState(null);

    useEffect(() => {
        (async () => {
            if (!isMounted()) {
                return;

            }

            if (window[constants.SDK_WINDOW_KEY]) {
                setLoaded(true);
                return;
            }

            if (window[constants.PROMISE_WINDOW_KEY]) {
                await window[constants.PROMISE_WINDOW_KEY];
            } else {
                const sdkUrl = window[constants.SDK_URL_WINDOW_KEY];

                if (!sdkUrl) {
                    setError(constants.NO_SDK_ERROR);
                    return;
                }

                const promise = getScript(sdkUrl);

                window[constants.PROMISE_WINDOW_KEY] = promise;

                await promise;
            }

            setLoaded(true);
        })();
    }, [
        setError,
        isMounted
    ]);

    useEffect(() => {
        if (!loaded || !isMounted()) {
            return;
        }

        setSDK(
            new window[constants.SDK_WINDOW_KEY]
                .Sdk(
                    identityJwt,
                    {
                        mobileToken: trustJwt,
                        throwOnRecall: true,
                        // language: 'en_US',
                        faceLivenessSettings: {
                            startButton: {},
                            permissionButton: {}
                        },
                        enableTimer: true,
                        metadata
                    })
        );
    }, [
        isMounted,
        loaded,
        trustJwt,
        identityJwt,
        metadata
    ]);

    useEffect(() => {
        (async () => {
            if (!sdk || !isMounted()) {
                return;
            }

            try {
                // ensure there are no focused input elements before invoking the SDK
                document.activeElement?.blur();

                const verificationResult = await sdk.verifyPolicy(cpf, policy);

                if (verificationResult.isAuthorized) {
                    setResponse(verificationResult);
                } else {
                    setError(verificationResult);
                }
            } catch (exception) {
                setError(exception);
            }
        })();
    }, [
        isMounted,
        cpf,
        sdk,
        policy,
        setError,
        setResponse
    ]);

    return (
        <div className={style.container}>
            <Loader />
        </div>
    );
};
